import { Diagram, GraphObject, HTMLInfo, Node } from 'gojs';
import { OrchestrationGoJsCommandHandler } from '../../../utils/orchestration-gojs-command-handler';

const $ = GraphObject.make;

export const OrchestrationNodeContextMenu = () =>
  $(HTMLInfo, {
    show: (obj: GraphObject, diagram: Diagram) => {
      const { x, y } = diagram.lastInput.viewPoint;
      const commandHandler = diagram.commandHandler as OrchestrationGoJsCommandHandler;
      commandHandler.showCustomContextMenu(
        {
          position: { x, y },
          items: [
            {
              label: 'Delete Node',
              icon: ['fal', 'trash'],
              callback: () => commandHandler.deleteNode(obj.part as Node),
            },
          ],
        },
        diagram,
      );
    },
    hide: (diagram: Diagram) => {
      const commandHandler = diagram.commandHandler as OrchestrationGoJsCommandHandler;
      commandHandler.hideCustomContextMenu();
    },
  });
